import moment from "moment";
import React from "react";

const ViewCourseDetail = ({ res }) => {
  return (
    <div className="tab-pane fade active show" id="CourseDetails">
      <div className="CourseDetailsBody CourseDetailsBodyLi">
        <ul className="p-0">
          <li>
            <h5>Name of Course</h5>
            <p>{res?.title}</p>
          </li>
          <li>
            <h5>Category</h5>
            <p>{res?.categoryData?.[0]?.categoryName}</p>
          </li>
          <li>
            <h5>Topic</h5>
            <p>{res?.topicData?.[0]?.topicName}</p>
          </li>
          <li>
            <h5>Course Type</h5>
            <p>{res?.courseType}</p>
          </li>
          <li>
            <h5>Course Languages</h5>
            <p>English</p>
          </li>
          <li>
            <h5>Total Lectures</h5>
            <p>{res?.totalVideos}</p>
          </li>
          <li>
            <h5>Total Hours</h5>
            <p>{moment.utc(res?.duration * 1000).format("HH:mm:ss")}Hrs</p>
          </li>
        </ul>

        {res?.coursePrerequisites && (
          <>
            <h6>Course Prerequisites:</h6>
            <div
              className="WhatYouLearnUl mb-4"
              dangerouslySetInnerHTML={{ __html: res?.coursePrerequisites }}
            ></div>
          </>
        )}
        {res?.aboutTeacher && (
          <>
            <h6>About Teacher:</h6>
            <div
              className="WhatYouLearnUl mb-4"
              dangerouslySetInnerHTML={{ __html: res?.aboutTeacher }}
            ></div>
          </>
        )}

        <h6>What You'll Learn:</h6>
        <div
          className="WhatYouLearnUl"
          dangerouslySetInnerHTML={{ __html: res?.whatWillYouLearn }}
        ></div>

        {/* {res?.whatWillYouLearn} */}
        <h6> Why Take This Course:</h6>
        {res?.whyTakeThisCourse ? (
          <div
            className="WhatYouLearnUl"
            dangerouslySetInnerHTML={{ __html: res?.whyTakeThisCourse }}
          ></div>
        ) : (
          <ol>
            <li>
              Practical Application: Gain hands-on experience applicable across
              industries.
            </li>
            <li>
              Career Advancement: Boost your employability with sought-after
              Excel skills.
            </li>
            <li>Flexibility: Study at your own pace, anytime, anywhere.</li>
            <li>
              Expert Guidance: Learn from seasoned Excel professionals dedicated
              to your success.
            </li>
          </ol>
        )}
        <h6>Who Should Enroll:</h6>
        {res?.whoShouldEnroll ? (
          <div
            className="WhatYouLearnUl"
            dangerouslySetInnerHTML={{ __html: res?.whoShouldEnroll }}
          ></div>
        ) : (
          <ol>
            <li>Beginners and intermediate users seeking to excel in Excel.</li>
            <li>
              Professionals aiming to enhance productivity and data analysis.
            </li>
          </ol>
        )}
      </div>
    </div>
  );
};

export default ViewCourseDetail;
